import type { InjectionKey, MaybeRefOrGetter } from 'vue';

interface ActionListGroupContext {
  title?: MaybeRefOrGetter<string | null | undefined>;
}

export const ACTION_LIST_GROUP_CONTEXT: InjectionKey<ActionListGroupContext> = Symbol(
  __DEV__ ? 'ActionListGroup context' : '',
);
